module.exports = __webpack_public_path__ + "img/bg.380fb365.png";